import React from "react";
import { ArrowLeftIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";
export function HarbourIsleWest() {
  return <main className="flex min-h-screen w-full flex-col bg-amber-950 text-amber-50" data-id="element-164" data-mp="1u518pzjh8xzz">
      <section className="flex flex-1 items-center px-6 py-16 sm:px-10 lg:px-14" data-id="element-165" data-mp="1yw9iiwopyldo">
        <div className="mx-auto w-full max-w-3xl" data-id="element-166" data-mp="1yy450ffn2ljv">
          <Link to="/harbour-isle-properties" className="inline-flex items-center gap-2 text-sm font-bold text-amber-100 transition-[color] duration-200 hover:text-white" data-id="element-167" data-mp="23ub1ziq24mpo">
            <ArrowLeftIcon size={17} aria-hidden="true" data-id="element-168" data-mp="2cxc7bh73m9sa" />
            Back to Harbour Isle Properties
          </Link>
          <p className="mt-16 text-xs font-bold uppercase tracking-[0.18em] text-amber-300" data-id="element-169" data-mp="2hucclpw4j8ic">Harbour Isle · Fort Pierce</p>
          <h1 className="mt-5 font-display text-5xl leading-[0.92] sm:text-7xl" data-id="element-170" data-mp="ike056gp3t96">Harbour Isle West.</h1>
          <p className="mt-7 max-w-xl text-lg leading-8 text-amber-100" data-id="element-171" data-mp="nixjr07tgsyd">
            Available properties, rentals, and community information for Harbour Isle West are coming soon.
          </p>
        </div>
      </section>
      <SiteFooter tone="warm" data-id="element-172" data-mp="2bbx5un5rp56g" />
    </main>;
}